import { render, staticRenderFns } from "./SoundsTheSame.vue?vue&type=template&id=6be6433c&scoped=true&"
import script from "./SoundsTheSame.vue?vue&type=script&lang=js&"
export * from "./SoundsTheSame.vue?vue&type=script&lang=js&"
import style0 from "./SoundsTheSame.vue?vue&type=style&index=0&id=6be6433c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be6433c",
  null
  
)

export default component.exports